var React = require('react');

function Transfer (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m16.5 13.5 3 3-3 3M4.5 16.5h15M7.5 10.5l-3-3 3-3M19.5 7.5h-15","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Transfer.defaultProps = {"viewBox":"0 0 24 24","fill":"none","strokeWidth":"2.002"};

module.exports = Transfer;

Transfer.default = Transfer;
